import React from "react";
import "./Testimonials.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { testimonials } from "../../data";
import { BsStarFill } from "react-icons/bs";
import Reveal from "../motion/Reveal";

const Testimonials = () => {
    return (
        <Reveal as="section" id="testimonials">
            <h5 className="title">What Others Say</h5>
            <h2>Testimonials</h2>
            <div className="container testimonials__wrapper">
                <Swiper
                    modules={[Navigation, Pagination]}
                    spaceBetween={20}
                    slidesPerView={3}
                    navigation
                    pagination={{ clickable: true }}
                    breakpoints={{
                        320: { slidesPerView: 1 },
                        600: { slidesPerView: 2 },
                        1024: { slidesPerView: 3 },
                    }}
                >
                    {testimonials.map((t, index) => (
                        <SwiperSlide key={index}>
                            <div className="testimonial-card">
                                <div className="testimonial-stars">
                                    {[...Array(5)].map((_, i) => <BsStarFill key={i} />)}
                                </div>
                                <p>"{t.quote}"</p>
                                <div className="testimonial-author">
                                    <div className="author-avatar">
                                        {t.name.charAt(0).toUpperCase()}
                                    </div>
                                    <div className="author-info">
                                        <h3>{t.name}</h3>
                                        <small>{t.position}</small>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </Reveal>
    );
};

export default Testimonials;
